import { schema } from 'normalizr';

const vital = new schema.Entity('vitals');

export default vital;
